// extracted by mini-css-extract-plugin
export default {"card":"ReceptionNewConvForm_card__c6OOE","cardIcon":"ReceptionNewConvForm_cardIcon__j5kXK"};